import { getAgoraToken, getPlatformInfo } from './api/manage'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import { ELocalStorageKey, ERouterName, SystemTitleKey } from './types'
import { CURRENT_CONFIG } from './api/http/config'
import { closeContextMenu, getBuildsList } from './hooks/Cesium'
import { closeCurrentMedia } from './hooks/Cesium/draw-image'

router.beforeEach((to, from, next) => {
  if (to.path === '/share-video') {
    next()
    return
  }
  if (to.path.indexOf('/big-screen') > -1) {
    next()
    return
  }
  if (to.path === '/' + ERouterName.PILOT) {
    next()
    return
  }
  const Token = cookies.get(ELocalStorageKey.Token)
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  if (Token) {
    closeCurrentMedia()
    closeContextMenu()
    getBuildsList()
    store.commit('SET_SELECT_WAYLINE_INFO', null)
    if (to.name === 'ScenarioPlanDetail' || to.name === 'waylineEditPlanar' || to.name === 'waylineEdit' || to.name === ERouterName.DATA_UI) {
      store.commit('SET_HEADER_VISIBLE', false)
    } else {
      store.commit('SET_HEADER_VISIBLE', true)
    }
    if (workspace_id) {
      store.dispatch('getDevices', workspace_id)
      store.dispatch('getMarkList', workspace_id)
      store.dispatch('getCustumFlyList', workspace_id)
      store.dispatch('getCrawlerGetAll', workspace_id)
      store.dispatch('getCloundModelList', workspace_id)
    }
    if (!store.state.location.lat || !store.state.location.lon) {
      getPlatformInfo().then((res) => {
        if (!workspace_id) {
          store.dispatch('getDevices', res.data.workspace_id)
          store.dispatch('getMarkList', res.data.workspace_id)
          store.dispatch('getCustumFlyList', res.data.workspace_id)
          store.dispatch('getCrawlerGetAll', res.data.workspace_id)
          store.dispatch('getCloundModelList', res.data.workspace_id)
        }
        store.commit('SET_LOCATION', res.data)
        if (to.path === '/' + ERouterName.PROJECT) {
          next({
            path: '/' + ERouterName.WORKSPACE
          })
          return
        }
        if (to.path !== from.path) {
          next(true)
        } else {
          next(false) // 阻止重复路由跳转
        }
      }).catch(() => {
        cookies.remove(ELocalStorageKey.Token)
        next({
          path: '/' + ERouterName.PROJECT
        })
      })
    } else {
      if (to.path === '/' + ERouterName.PROJECT) {
        next({
          path: '/' + ERouterName.WORKSPACE
        })
        return
      }
      if (to.path !== from.path) {
        next(true)
      } else {
        next(false) // 阻止重复路由跳转
      }
    }
  } else {
    if (to.path === '/' + ERouterName.PROJECT) {
      next()
      return
    }
    next({
      path: '/'
    })
  }
})
